<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>スタッフ管理</template>
      <template v-slot:annotation>
        スタッフの一覧を表示します。情報を編集する場合は、データをクリックして操作を行ってください。
      </template>
    </PageHeader>

    <v-row class="text-center px-3">
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select
          label="部署"
          v-model="departmentSearch"
          item-text="label"
          item-value="value"
          :items="departmentItem"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2">
        <FormInputComponent
          label="氏名"
          v-model="userNameSearch"
          :length="10"
        />
      </v-col>
      <v-col cols="6" md="4" lg="2">
        <Button @click="get_member()" color="primary">検索</Button>
      </v-col>
      <v-col cols="6" md="4" lg="2">
        <Button @click="onClickStaffEditOpen(null)" color="info"
          >新規追加</Button
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="スタッフは見つかりませんでした。新規追加ボタンよりスタッフを設定してください。"
        >
          <template v-slot:[`item.USER_AVATER`]="{ item }">
            <Avatar
              v-if="item.USER_AVATER"
              :src="item.USER_AVATER"
              :size="40"
              class="mr-2"
            />
          </template>

          <template v-slot:[`item.EDIT`]="{ item }">
            <Button
              color="secondary"
              class="mr-1"
              @click="onClickStaffEditOpen(item)"
              :small="true"
              >編集</Button
            >
          </template>
          <template v-slot:[`item.GRADE`]="{ item }">
            <Button
              v-if="isJinji"
              color="secondary"
              class="mr-1"
              @click="onClickUserGrade(item)"
              :small="true"
              >等級管理</Button
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <edit ref="edit" @edit="editStaffInfo"> </edit>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import axios from 'axios';
import config from '../../const.js';
import moment from 'moment';
import edit from '@/components/pages/Manages/StaffEditDialog.vue';
import message from '../../message.js';
import { getSessionStorageItem, makeDateFormatStr } from '../../common.js';
import { Buffer } from 'buffer';
export default {
  components: {
    edit,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'スタッフ管理',
          route: 'StaffSetting',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      userNameSearch: '',
      departmentSearch: '',
      confirm: false,
      isJinji: false,

      // パラメータ取得
      organizationName: '',
      loginName: '',
      dispPosition: '',
      sessionId: '',
      departmentItem: [],
      items: [],
      headers: [
        {
          text: '',
          align: 'left',
          value: 'USER_AVATER',
          width: '10%',
        },
        {
          text: '氏名',
          align: 'left',
          value: 'USER_NAME',
          width: '20%',
        },
        {
          text: '部署',
          align: 'left',
          value: 'DEPARTMENT_NAME',
          width: '20%',
        },
        {
          text: '役職',
          align: 'left',
          value: 'POSITION_NAME',
          width: '20%',
        },
        {
          text: '',
          align: '',
          value: 'EDIT',
        },
        {
          text: '',
          align: '',
          value: 'GRADE',
        },
      ],
    };
  },
  created() {
    let userInfo = getSessionStorageItem();
    if (userInfo) {
      this.expiration = userInfo.ORGANIZATION_EXPIRATION;
    }
    if (this.expiration == config.EXPIRATION_PURASUNOKI) {
      // プラスの氣
      this.isJinji = false;
    } else {
      // 人事考課
      this.isJinji = true;
    }
  },

  mounted() {
    this.get_department();
    this.get_member();
  },

  methods: {
    onClickUserGrade(item) {
      this.$router.push({
        name: 'StaffGradeSetting',
        params: {
          staffId: Buffer.from(item.USER_ID).toString('base64'),
        },
      });
    },
    onClickStaffEditOpen(item) {
      // スタッフ情報編集画面を表示
      if (item == null) {
        this.$refs.edit.open(null, { color: 'red' });
      } else {
        this.$refs.edit.open(item, { color: 'red' });
      }
    },

    editStaffInfo() {
      this.get_member();
    },

    async get_department() {
      this.loading = true;
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          vm.departmentItem.push({ label: '', value: '' });
          for (let i = 0; i < response.data.length; i++) {
            var item = {
              label: response.data[i].DEPARTMENT_NAME,
              value: response.data[i].DEPARTMENT_KEY,
            };
            vm.departmentItem.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },

    async get_member() {
      this.loading = true;
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      let vm = this;

      if (this.userNameSearch == null || !this.userNameSearch.trim()) {
        this.userNameSearch = config.EMPTY_STRING;
      }
      if (this.departmentSearch == null || !this.departmentSearch) {
        this.departmentSearch = config.EMPTY_STRING;
      }

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/members/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            this.userNameSearch +
            '/' +
            this.departmentSearch
        )
        .then((response) => {
          // スタッフデータ取得
          vm.items = response.data;
          // スタッフデータ編集
          for (var j = 0; j < vm.items.length; j++) {
            // 勤務開始日
            if (
              vm.items[j].START_WORKING_AT != null &&
              vm.items[j].START_WORKING_AT.trim()
            ) {
              vm.items[j].START_WORKING_AT =
                makeDateFormatStr(vm.items[j].START_WORKING_AT, '/', '/', '') +
                ' ～';
              if (
                vm.items[j].END_WORKING_AT != null &&
                vm.items[j].END_WORKING_AT != config.END_WORKING_AT_INIT
              ) {
                vm.items[j].START_WORKING_AT =
                  vm.items[j].START_WORKING_AT +
                  makeDateFormatStr(vm.items[j].END_WORKING_AT, '/', '/', '');
              }
            }
            // アバター接続URL作成
            vm.items[j].USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              vm.items[j].USER_AVATER +
              '?' +
              moment().format('YYYYMMDDHHmmss');
          }

          // 検索文字調整
          if (this.userNameSearch == config.EMPTY_STRING) {
            this.userNameSearch = '';
          }
          if (this.departmentSearch == config.EMPTY_STRING) {
            this.departmentSearch = '';
            this.departmentItem.values = '';
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
  },
};
</script>
